import React from 'react';
import PropTypes from 'prop-types';

import OnDeleteIcon from '../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../icons/OnEditIcon';

import card from '../../../commonStyles/card.module.css';

const AdditionalContactCard = ({ contact, onEditContact, onDeleteContact, isDisabled = false }) => {
    return (
        <div className={card.card} data-testid="additional_contact_card">
            <div className={`${card.banner}`}>
                <h6>Contact Details</h6>
                {!isDisabled && (
                    <div className={card.bannerActions}>
                        <span
                            className={card.editIcons}
                            data-testid="additional_contact_card_icons">
                            <OnEditIcon
                                onEdit={() => onEditContact(contact)}
                                active={!isDisabled}
                            />
                            <OnDeleteIcon
                                onDelete={() => onDeleteContact(contact)}
                                active={!isDisabled}
                            />
                        </span>
                    </div>
                )}
            </div>
            <div className={card.content}>
                <p className={card.textRows}>
                    {contact.firstName || ''} {contact.lastName || ''}{' '}
                    {contact.relationshipToParticipant
                        ? `(${contact.relationshipToParticipant})`
                        : ''}
                    <br />
                    {contact.addressLine1}
                    <br />
                    {contact.postcode}
                    <br />
                    {contact.phoneNumber}
                    <br />
                    {contact.emailAddress}
                </p>
            </div>
        </div>
    );
};

AdditionalContactCard.propTypes = {
    contact: PropTypes.object,
    onEditContact: PropTypes.func,
    onDeleteContact: PropTypes.func,
    isDisabled: PropTypes.bool
};

export default AdditionalContactCard;
